import { Box, Collapse } from '@mui/material';
import { ReactNode } from 'react';

import { SUBMENU_TIMEOUT } from './MenuConstants';

/**
 * Custom Collapse component with slide-down animation
 */
export const CollapseWithSlide = ({
  in: inProp,
  children,
  timeout = SUBMENU_TIMEOUT,
}: {
  in: boolean;
  children: ReactNode;
  timeout?: number;
}) => {
  return (
    <Collapse
      in={inProp}
      timeout={timeout}
      unmountOnExit
      easing={{
        enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
        exit: 'cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <Box
        sx={{
          transform: inProp ? 'translateY(0)' : 'translateY(-20px)',
          opacity: inProp ? 1 : 0,
          transition: `all ${timeout}ms cubic-bezier(0.4, 0, 0.2, 1)`,
        }}
      >
        {children}
      </Box>
    </Collapse>
  );
};
